import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { setSelectedCollectionId } from "store/vino/productCollectionsSlice";
import { resetProducts } from "store/vino/productsSlice";

const StyledListItem = styled(ListItem)(({ theme }) => ({
	color: "inherit!important",
	textDecoration: "none!important",
	height: 40,
	width: "100%",
	borderRadius: 6,
	marginBottom: 4,
	"&.active": {
		backgroundColor:
			theme.palette.mode === "light"
				? "rgba(0, 0, 0, .05)!important"
				: "rgba(255, 255, 255, .1)!important",
		pointerEvents: "none",
		"& .list-item-icon": {
			color: "inherit",
		},
	},
	"& .list-item-icon": {
		fontSize: 16,
		width: 16,
		height: 16,
		marginRight: 16,
	},
}));

const ProductCollectionListItem = ({ collection }) => {
	const dispatch = useDispatch();
	const selectedCollectionId = useSelector(
		({ vino }) => vino.productCollections.selectedCollectionId
	);
	const handleSelect = () => {
		dispatch(setSelectedCollectionId(collection.id));
		dispatch(resetProducts());
	};

	return (
		<StyledListItem
			button
			key={collection.id}
			onClick={handleSelect}
			selected={selectedCollectionId === collection.id}
		>
			<ListItemText primary={collection.name} disableTypography />
		</StyledListItem>
	);
};

ProductCollectionListItem.propTypes = {
	collection: PropTypes.object.isRequired,
};

export default ProductCollectionListItem;
